import React, { useState } from 'react';

export const INSURANCE_PROVIDERS = [
  'WA Apple Health (Medicaid)',
  'Molina Healthcare',
  'Coordinated Care',
  'UnitedHealthcare Community Plan',
  'Community Health Plan of Washington (CHPW)',
  'Wellpoint',
  'Premera Blue Cross',
  'Regence BlueShield',
  'Kaiser Permanente',
  'Aetna',
  'Cigna',
  'Providence Health Plan',
  'HMA (Healthcare Management Administrators)',
  'First Choice Health',
  'Medicare',
  'TRICARE (Military)',
  'TriWest (Veterans Affairs)',
  'Indian Health Service (IHS)',
  'Private insurance',
  'Private pay',
  'Sliding scale / low cost',
  'Free',
];

// Parse insurance_accepted from DB — handles both JSON array and legacy plain text
export function parseInsurance(raw) {
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : raw.trim() ? [raw.trim()] : [];
  } catch {
    return raw.trim() ? [raw.trim()] : [];
  }
}

export default function InsuranceSelect({ selected, onChange, inputCls }) {
  const [resetKey, setResetKey] = useState(0);
  const available = INSURANCE_PROVIDERS.filter((p) => !selected.includes(p));

  const handleAdd = (e) => {
    const val = e.target.value;
    if (val && !selected.includes(val)) {
      onChange([...selected, val]);
      setResetKey((k) => k + 1);
    }
  };

  const remove = (p) => onChange(selected.filter((x) => x !== p));

  return (
    <div>
      <select
        key={resetKey}
        defaultValue=""
        onChange={handleAdd}
        className={`${inputCls} bg-white dark:bg-gray-700`}
      >
        <option value="" disabled>Add insurance provider…</option>
        {available.map((p) => (
          <option key={p} value={p}>{p}</option>
        ))}
        {available.length === 0 && (
          <option disabled>All providers added</option>
        )}
      </select>

      {selected.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mt-2">
          {selected.map((p) => (
            <span
              key={p}
              className="inline-flex items-center gap-1 bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 text-xs font-medium px-2.5 py-1 rounded-full border border-blue-200 dark:border-blue-700"
            >
              {p}
              <button
                type="button"
                onClick={() => remove(p)}
                className="ml-0.5 text-blue-400 hover:text-red-500 leading-none text-sm font-bold"
              >
                ×
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
